import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});

function GenericDatePicker({ className, ...rest }) {
  const { t } = useTranslation('Common');
  const [date, setDate] = React.useState(rest.selectedDate);
  const handleLocalDateChange = value => {
    setDate(value);
    rest.handleDateChange(moment(value).format('YYYY-MM-DD'));
  };
  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={trLocale}>
        <KeyboardDatePicker
          color="primary"
          size="small"
          inputVariant="outlined"
          label={rest.datePickerLabel}
          invalidDateMessage={t('txtWrongDateFormat')}
          format={t('dateFormat')}
          variant="outlined"
          value={date}
          onChange={e => handleLocalDateChange(e)}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
          fullWidth
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}
GenericDatePicker.propTypes = {
  className: PropTypes.string
};

export default GenericDatePicker;
